import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  scrollButton: {
    flex: '0 0 32px',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  tableContainer: {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    background: 'white',
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[1],
    width: '100%',
  },
}));
